import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { getFails } from '../fails.routes';
import { FailsPageModel } from '../types';

export function useFails(
  startDate: string | null,
  endDate: string | null,
  fundId: string,
  options?: Omit<
    UseQueryOptions<FailsPageModel, AxiosError<any>>,
    'queryKey' | 'queryFn'
  >,
) {
  return useQuery<FailsPageModel, AxiosError<any>>({
    queryKey: ['fails', startDate, endDate, fundId],
    queryFn: () => getFails(startDate!, endDate!, fundId),
    enabled: !!startDate && !!endDate && !!fundId,
    ...options,
  });
}
